import React from 'react';

interface Proptypes {
  className?: string;
}

const PencilIcon = ({ className }: Proptypes) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className || ''}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0082 1.15763C12.6624 0.503445 13.723 0.503445 14.3772 1.15763L16.8427 3.62307C17.4968 4.27726 17.4968 5.33791 16.8427 5.9921L6.61806 16.2167C6.3852 16.4495 6.08888 16.6086 5.76613 16.674L2.6744 17.3003C2.12401 17.4118 1.55438 17.2401 1.1573 16.843C0.760212 16.4459 0.58851 15.8763 0.700001 15.3259L1.3263 12.2342C1.39168 11.9114 1.55074 11.6151 1.7836 11.3822L12.0082 1.15763ZM2.70286 13.8762L2.81058 13.3444L4.65587 15.1897L4.12413 15.2974L2.34181 15.6585L2.70286 13.8762ZM6.15045 14.3153L3.68502 11.8498L10.8763 4.65856L13.3417 7.124L6.15045 14.3153ZM14.5262 5.93948L15.6581 4.80758L14.4736 3.62307L14.3772 3.52666L13.1927 2.34215L12.0608 3.47405L14.5262 5.93948Z"
        fill="#84929A"
      />
    </svg>
  );
};

export default PencilIcon;
